
///
/// Burger menu
///
 
import { SetUpMobileNavExpanders } from './_mobile-nav-expander';

window.SetUpBurgerNav = function() {

	var nav = document.querySelector('#MobileNavigation');
	var burgerMenu = document.querySelector('#BurgerMenu');
	var menuItems = document.querySelectorAll('#MobileNavigationList .mobile-navigation__list-item--level-1 a');	
	var expandedClassName = 'expanded';

	var searchToggleIcon = document.querySelector('.magnifying-glass');
	var searchForm = document.querySelector('#SearchForm')

	////
	//// remove the display none from the mobile nav
	//// after a short delay
	//window.setTimeout(function () {
	//	document.querySelector('.mobile-navigation__drop-area').style.display = 'block';
	//	document.querySelector('.mobile-navigation__drop-area').style.removeProperty('height');
	//}, 300);
	

	//
	// Add a click event handler to the burger menu element to toggle the showing and hiding of the nav elemet
	//
	burgerMenu.addEventListener('click', function () {
		if (nav.classList.contains(expandedClassName)) {
			// menu is already expanded -> close it
			this.setAttribute('aria-expanded', 'false');
			nav.classList.remove(expandedClassName);
			burgerMenu.classList.remove(expandedClassName);
			document.querySelector('.mobile-navigation__drop-area').style.display = 'none';
			document.querySelector('.mobile-navigation__drop-area').style.height = 0;
	// set tabindexes
			// toggleTabIndex(menuItemsScope, false);
		} else {
			// is the search box in view?
			if (searchForm.classList.contains(expandedClassName)) {
				// close it
				searchForm.classList.remove(expandedClassName);
				searchToggleIcon.setAttribute('aria-expanded', 'false');
			}
			// menu is not expanded -> open it
			nav.classList.add(expandedClassName);
			burgerMenu.classList.add(expandedClassName);
			this.setAttribute('aria-expanded', 'true');

					document.querySelector('.mobile-navigation__drop-area').style.display = 'block';
		document.querySelector('.mobile-navigation__drop-area').style.removeProperty('height');

// set tabindexes
			// toggleTabIndex(menuItemsScope, true);
			// set focus on the first menu item
			// todo : menuItems[0].focus();
		}
	});

	SetUpMobileNavExpanders();
}

if (document.readyState !== 'loading') {
	window.SetUpBurgerNav();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetUpBurgerNav();
	});
}